import type { IconProps } from "types";

const ChannelPhysique = ({ color = "#B3B3B3", width = "20px", height = "20px" }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 5H3.33333C2.8731 5 2.5 5.3731 2.5 5.83333V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H16.6667C17.1269 17.5 17.5 17.1269 17.5 16.6667V5.83333C17.5 5.3731 17.1269 5 16.6667 5Z"
        stroke={color}
        strokeWidth="1.40351"
        strokeLinejoin="round"
      />
      <path
        d="M7.47925 10.0034H12.4792"
        stroke={color}
        strokeWidth="1.40351"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.41683L5.41667 2.0835H14.5833L17.5 5.41683"
        stroke={color}
        strokeWidth="1.40351"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ChannelPhysique;
